import { Page, PageBody, PageHeader } from "@/components/app-layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useOrganizationData } from "@/data/use-organizations-data";
import { useParams } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { toast } from "sonner";

export default function GlobalAdminOrganizationDetailsPage() {
  const { organizationUuid } = useParams({ strict: false }) as {
    organizationUuid?: string;
  };
  const { organization, renameOrganization, isRenaming } =
    useOrganizationData(organizationUuid);
  const [name, setName] = useState("");

  useEffect(() => {
    if (organization) {
      setName(organization.name);
    }
  }, [organization]);

  if (!organization || !organizationUuid) return null;

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const nextName = name.trim();
    if (!nextName || nextName === organization.name) return;

    try {
      await renameOrganization({ organizationUuid, name: nextName });
      toast.success("Organization renamed.");
    } catch {
      toast.error("Failed to rename organization.");
    }
  };

  return (
    <Page>
      <PageHeader>
        <PageHeader.Title>Details</PageHeader.Title>
      </PageHeader>
      <PageBody innerClassName="gap-8">
        <form onSubmit={handleSubmit} className="flex max-w-md flex-col gap-4">
          <div className="space-y-1.5">
            <Label htmlFor="organization-name">Name</Label>
            <Input
              id="organization-name"
              value={name}
              onChange={(event) => setName(event.target.value)}
              required
            />
          </div>
          <div>
            <Button
              type="submit"
              disabled={
                isRenaming || !name.trim() || name.trim() === organization.name
              }
            >
              {isRenaming ? "Saving…" : "Save"}
            </Button>
          </div>
        </form>
        <dl className="grid grid-cols-[100px_1fr] items-center gap-y-2">
          <div className="contents">
            <dt className="text-sm font-semibold text-gray-500">Slug</dt>
            <dd>{organization.slug}</dd>
          </div>
          <div className="contents">
            <dt className="text-sm font-semibold text-gray-500">Bucket</dt>
            <dd>{organization.bucketName}</dd>
          </div>
          <div className="contents">
            <dt className="text-sm font-semibold text-gray-500">UUID</dt>
            <dd>{organization.uuid}</dd>
          </div>
        </dl>
      </PageBody>
    </Page>
  );
}
